import { catchError, switchMap } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { merge, isEmpty, get as getValue } from 'lodash';
import { ConfigService } from '@app/core/config.service';
import { DEFAULT_APP_VALUES, ENDPOINTS } from '@app/app.constants';
import { ProfileService } from '../profile/profile.service';
import { SpecialOffersService } from '../special-offers/special-offers.service';
import * as i0 from "@angular/core";
import * as i1 from "../../config.service";
import * as i2 from "@angular/common/http";
import * as i3 from "../profile/profile.service";
import * as i4 from "../special-offers/special-offers.service";
var CruiseListingDataService = /** @class */ (function () {
    function CruiseListingDataService(configService, httpClient, profileService, specialOffersService) {
        this.configService = configService;
        this.httpClient = httpClient;
        this.profileService = profileService;
        this.specialOffersService = specialOffersService;
        // Common default availability body params
        this.defaultAvailParams = {
            currency: DEFAULT_APP_VALUES.currency,
            filters: [],
            partyMix: [],
            region: DEFAULT_APP_VALUES.region,
            storeId: DEFAULT_APP_VALUES.storeId
        };
        this.webApiUrl = this.configService.getValue('webApiUrl');
    }
    /**
     * Get available products
     * @param params Product's params to retrieve
     * @returns Available products
     */
    CruiseListingDataService.prototype.getAvailableProducts = function (params) {
        var _this = this;
        return this.profileService.getAffiliations().pipe(switchMap(function (affiliations) {
            var bodyParams = merge({}, _this.defaultAvailParams, params);
            if (!params.promoCode) {
                bodyParams.affiliations = affiliations;
            }
            return _this.httpClient.post("" + _this.webApiUrl + ENDPOINTS.availableProducts, bodyParams);
        }), catchError(function (error) {
            return _this.handleCruiseListingServiceError(error);
        }));
    };
    /**
     * Get available sailings
     * @param params Sailing's params to retrieve
     * @returns Available sailings
     */
    CruiseListingDataService.prototype.getAvailableSailings = function (params) {
        var _this = this;
        return this.profileService.getAffiliations().pipe(switchMap(function (affiliations) {
            var bodyParams = merge({}, _this.defaultAvailParams, params);
            if (!params.promoCode) {
                bodyParams.affiliations = affiliations;
            }
            return _this.httpClient.post("" + _this.webApiUrl + ENDPOINTS.availableSailings, bodyParams);
        }), catchError(function (error) {
            return _this.handleCruiseListingServiceError(error);
        }));
    };
    /**
     * Retrieves the filters options data for the Quick Quote
     * @param portOfCall port of call
     * @param availabilityParam Product's params to retrieve
     * @returns Filter options
     */
    CruiseListingDataService.prototype.getFilters = function () {
        var _this = this;
        return this.profileService.getAffiliations().pipe(switchMap(function (affiliations) {
            // set cache to last 5 minutes = 300000 ma
            var date = new Date();
            var dateTime = Math.round(date.getTime() / 300000);
            var params = new HttpParams().set('time', dateTime.toString());
            if (!isEmpty(affiliations)) {
                params = params.set('affiliations', JSON.stringify(affiliations[0]));
            }
            var env = _this.configService.getValue('environment');
            if (env === 'load') {
                env = 'lt01.';
            }
            else if (env !== 'prod') {
                env = env + '.';
            }
            else {
                env = '';
            }
            var headers = { 'X-Page-Id': 'https://' + env + 'disneycruise.disney.go.com' };
            return _this.httpClient.get("" + _this.webApiUrl + ENDPOINTS.filters, { params: params, headers: headers });
        }));
    };
    /**
     * Retrieves whats included modal params used to consume the service
     * @returns Whats included modal service params
     */
    CruiseListingDataService.prototype.getWhatsIncludedModalSvcParams = function () {
        return {
            url: "" + this.webApiUrl + ENDPOINTS.whatsIncludedModal,
            language: DEFAULT_APP_VALUES.language
        };
    };
    /**
     * Handles the http response for cruise listing service errors and rethrows an error of type CruiseListingServiceError
     * @param error The http error response
     * @returns The cruise service listing error including the initial http response
     * plus any additional handling info.
     */
    CruiseListingDataService.prototype.handleCruiseListingServiceError = function (error) {
        var errorCode = getValue(error, 'error.errorCode') || getValue(error, 'error.message.errorCode');
        var cruiseListingServiceError = {
            httpErrorResponse: error,
            isCastError: false
        };
        return throwError(cruiseListingServiceError);
    };
    CruiseListingDataService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CruiseListingDataService_Factory() { return new CruiseListingDataService(i0.ɵɵinject(i1.ConfigService), i0.ɵɵinject(i2.HttpClient), i0.ɵɵinject(i3.ProfileService), i0.ɵɵinject(i4.SpecialOffersService)); }, token: CruiseListingDataService, providedIn: "root" });
    return CruiseListingDataService;
}());
export { CruiseListingDataService };
